<template>
  <div class="landing-page">
    <!-- Header -->
    <header class="header">
      <div class="header-content">
        <div class="logo-section">
          <div class="kpmg-logo" @click="navigateToHome">
            <img src="/kpmg-logo-blue.svg" alt="KPMG" class="kpmg-logo-img" />
          </div>
          <div class="product-title">
            <h1>K-IMPACT</h1>
            <p class="subtitle">KPMG Infrastructure Management, Planning, and Assessment for Critical Transformation Platform</p>
          </div>
        </div>
        <nav class="nav-menu">
          <a href="#features">Features</a>
          <a href="#about">About</a>
          <button @click="enterTool" class="cta-button">Get Started</button>
        </nav>
      </div>
    </header>

    <!-- Hero Section -->
    <section class="hero">
      <div class="hero-content">
        <div class="hero-text">
          <h2>Planning and Prioritizing PPP Project with Data-Driven Insights</h2>
          <p class="hero-description">
            Our comprehensive K-IMPACT Platform empowers governments and organizations 
            to make informed decisions about public-private partnership projects through advanced assessment frameworks, 
            risk analysis, and strategic planning capabilities.
          </p>
          <div class="hero-actions">
            <button @click="enterTool" class="primary-button">Start Assessment</button>
            <button @click="scrollToFeatures" class="secondary-button">Learn More</button>
          </div>
          <div class="trust-indicators">
            <span class="indicator">✓ KPMG In-Depth Experience</span>
            <span class="indicator">✓ Climate-Smart PPP</span>
            <span class="indicator">✓ Risk-Based Analysis</span>
          </div>
        </div>
        <div class="hero-visual">
          <div class="stats-scorecards">
            <div class="scorecard">
              <div class="scorecard-icon">📊</div>
              <div class="scorecard-content">
                <h3>24</h3>
                <p>No. of Projects</p>
              </div>
            </div>
            <div class="scorecard">
              <div class="scorecard-icon">🏛️</div>
              <div class="scorecard-content">
                <h3>8</h3>
                <p>No. of Implementing Government Agencies</p>
              </div>
            </div>
            <div class="scorecard">
              <div class="scorecard-icon">💰</div>
              <div class="scorecard-content">
                <h3>$3.2B</h3>
                <p>Total Value (USD)</p>
              </div>
            </div>
            <div class="scorecard">
              <div class="scorecard-icon">🏗️</div>
              <div class="scorecard-content">
                <h3>6</h3>
                <p>No. of Sectors</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Features Section -->
    <section id="features" class="features">
      <div class="container">
        <h2 class="section-title">Comprehensive Assessment Framework</h2>
        <div class="features-grid">
          <div class="feature-card">
            <div class="feature-icon">📊</div>
            <h3>Multi-Criteria Assessment</h3>
            <p>Evaluate projects across 9 comprehensive dimensions including strategic suitability, feasibility, and risk assessment.</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">🌍</div>
            <h3>Climate-Smart Analysis</h3>
            <p>Integrated climate change risk exposure assessment and climate-smart PPP suitability evaluation.</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">💼</div>
            <h3>Portfolio Management</h3>
            <p>Compare and prioritize multiple projects with advanced pipeline analytics and dashboard visualization.</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">📈</div>
            <h3>Real-time Analytics</h3>
            <p>Dynamic dashboards with interactive charts and KPI tracking for informed decision-making.</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">🔒</div>
            <h3>Risk Management</h3>
            <p>Comprehensive risk assessment framework covering financial, technical, and institutional risks.</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">📋</div>
            <h3>Report Generation</h3>
            <p>Automated report generation with detailed analysis, recommendations, and export capabilities.</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Assessment Categories -->
    <section class="assessment-categories">
      <div class="container">
        <h2 class="section-title">Assess and Prioritize your infrastructure project in 8 Dimension Framework</h2>
        <div class="categories-grid">
          <div class="category-item">
            <span class="category-number">01</span>
            <h4>Strategic Suitability</h4>
            <p>Alignment with strategic objectives</p>
          </div>
          <div class="category-item">
            <span class="category-number">02</span>
            <h4>preliminary feasibility</h4>
            <p>Technical and economic viability</p>
          </div>
          <div class="category-item">
            <span class="category-number">03</span>
            <h4>Risk Assessment</h4>
            <p>Comprehensive risk evaluation</p>
          </div>
          <div class="category-item">
            <span class="category-number">04</span>
            <h4>PPP Suitability</h4>
            <p>Public-private partnership viability</p>
          </div>
          <div class="category-item">
            <span class="category-number">05</span>
            <h4>Fiscal Affordability</h4>
            <p>Financial sustainability analysis</p>
          </div>
          <div class="category-item">
            <span class="category-number">06</span>
            <h4>Institutional Capability</h4>
            <p>Organizational readiness assessment</p>
          </div>
          <div class="category-item">
            <span class="category-number">07</span>
            <h4>Climate Risk Exposure</h4>
            <p>Environmental impact evaluation</p>
          </div>
          <div class="category-item">
            <span class="category-number">08</span>
            <h4>Climate-Smart PPP</h4>
            <p>Sustainable development alignment</p>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA Section -->
    <section class="cta-section">
      <div class="container">
        <div class="cta-content">
          <h2>Ready to Transform Your Infrastructure Planning?</h2>
          <p>Join leading organizations worldwide in making data-driven infrastructure investment decisions.</p>
          <button @click="enterTool" class="cta-button-large">Start Your Assessment Today</button>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-left">
            <div class="kpmg-logo-footer">KPMG</div>
            <p>© 2024 KPMG. All rights reserved.</p>
          </div>
          <div class="footer-right">
            <p>KPMG Infrastructure Project Strategic Assessment Platform</p>
            <p>Strategic Assessment & Decision Support Platform</p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'LandingPage',
  methods: {
    enterTool() {
      this.$emit('enter-tool')
    },
    scrollToFeatures() {
      document.getElementById('features').scrollIntoView({ behavior: 'smooth' })
    },
    navigateToHome() {
      this.$emit('enter-tool')
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.landing-page {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #333;
  line-height: 1.6;
}

/* Header */
.header {
  background: #fff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.kpmg-logo {
  cursor: pointer;
  transition: transform 0.3s ease;
  display: flex;
  align-items: center;
}

.kpmg-logo:hover {
  transform: scale(1.05);
}

.kpmg-logo-img {
  height: 40px;
  width: auto;
}

.product-title h1 {
  font-size: 1.1rem;
  color: #333;
  font-weight: 600;
}

.subtitle {
  font-size: 0.9rem;
  color: #666;
  margin: 0;
}

.nav-menu {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.nav-menu a {
  text-decoration: none;
  color: #333;
  font-weight: 500;
  transition: color 0.3s;
}

.nav-menu a:hover {
  color: rgb(0, 51, 141);
}

.cta-button {
  background: rgb(0, 51, 141);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 25px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.cta-button:hover {
  background: rgb(12, 35, 60);
  transform: translateY(-1px);
}

/* Hero Section */
.hero {
  padding: 120px 2rem 80px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.hero-content {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 4rem;
  align-items: center;
}

.hero-text h2 {
  font-size: 2.8rem;
  color: rgb(51, 51, 51);
  margin-bottom: 1.5rem;
  line-height: 1.3;
  font-weight: 700;
}

.hero-description {
  font-size: 1.1rem;
  color: rgb(102, 102, 102);
  margin-bottom: 2rem;
  line-height: 1.7;
  max-width: 90%;
}

.hero-actions {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
}

.primary-button {
  background: rgb(0, 51, 141);
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 30px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.primary-button:hover {
  background: rgb(12, 35, 60);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 51, 141, 0.3);
}

.secondary-button {
  background: transparent;
  color: rgb(0, 51, 141);
  border: 2px solid rgb(0, 51, 141);
  padding: 1rem 2rem;
  border-radius: 30px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.secondary-button:hover {
  background: rgb(0, 51, 141);
  color: white;
}

.trust-indicators {
  display: flex;
  gap: 2rem;
}

.indicator {
  color: rgb(0, 192, 174);
  font-weight: 500;
  font-size: 0.9rem;
}

/* Stats Scorecards */
.stats-scorecards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 2rem;
  width: 100%;
  max-width: 600px;
  min-height: 380px;
}

.scorecard {
  background: linear-gradient(135deg, rgb(172, 234, 255), rgb(118, 210, 255));
  color: rgb(12, 35, 60);
  padding: 2.5rem;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(172, 234, 255, 0.3);
  display: flex;
  align-items: center;
  gap: 1.5rem;
  transition: transform 0.3s, box-shadow 0.3s;
  border: none;
  height: 160px;
  width: 100%;
}

.scorecard:hover {
  transform: translateY(-10px);
  box-shadow: 0 18px 45px rgba(172, 234, 255, 0.4);
}

.scorecard-icon {
  font-size: 3rem;
  background: rgba(255, 255, 255, 0.4);
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  backdrop-filter: blur(15px);
  border: 3px solid rgba(255, 255, 255, 0.6);
}

.scorecard-content h3 {
  font-size: 2.5rem;
  color: rgb(12, 35, 60);
  margin: 0;
  font-weight: 700;
  text-shadow: 0 1px 3px rgba(255, 255, 255, 0.5);
}

.scorecard-content p {
  color: rgba(12, 35, 60, 0.8);
  margin: 0;
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  line-height: 1.4;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.3);
}

/* Features Section */
.features {
  padding: 80px 2rem;
  background: white;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  text-align: center;
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 3rem;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2rem;
}

.feature-card {
  background: #f8f9fa;
  padding: 2rem;
  border-radius: 15px;
  text-align: center;
  transition: transform 0.3s, box-shadow 0.3s;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(0,0,0,0.1);
}

.feature-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.feature-card h3 {
  color: #333;
  margin-bottom: 1rem;
  font-size: 1.3rem;
}

.feature-card p {
  color: #666;
  line-height: 1.6;
}

/* Assessment Categories */
.assessment-categories {
  padding: 80px 2rem;
  background: #f8f9fa;
}

.categories-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
}

.category-item {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  border-left: 4px solid rgb(0, 51, 141);
  transition: transform 0.3s;
}

.category-item:hover {
  transform: translateX(5px);
}

.category-number {
  background: rgb(0, 51, 141);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-weight: 700;
  font-size: 0.9rem;
}

.category-item h4 {
  margin: 1rem 0 0.5rem 0;
  color: #333;
  font-size: 1.1rem;
}

.category-item p {
  color: #666;
  font-size: 0.9rem;
}

/* CTA Section */
.cta-section {
  padding: 80px 2rem;
  background: linear-gradient(135deg, rgb(0, 51, 141), rgb(12, 35, 60));
  color: white;
}

.cta-content {
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
}

.cta-content h2 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.cta-content p {
  font-size: 1.2rem;
  margin-bottom: 2rem;
  opacity: 0.9;
}

.cta-button-large {
  background: white;
  color: rgb(0, 51, 141);
  border: none;
  padding: 1.2rem 3rem;
  border-radius: 30px;
  font-size: 1.2rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s;
}

.cta-button-large:hover {
  background: rgb(229, 229, 229);
  transform: translateY(-2px);
  box-shadow: 0 10px 30px rgba(255, 255, 255, 0.3);
}

/* Footer */
.footer {
  background: #333;
  color: white;
  padding: 2rem;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}

.kpmg-logo-footer {
  font-size: 1.5rem;
  font-weight: bold;
  letter-spacing: 2px;
  margin-bottom: 0.5rem;
}

.footer-right {
  text-align: right;
}

.footer-right p {
  margin: 0.25rem 0;
  opacity: 0.8;
}

/* Responsive Design */
@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
  }
  
  .hero-content {
    grid-template-columns: 1fr;
    gap: 2rem;
    text-align: center;
  }
  
  .hero-text h2 {
    font-size: 2rem;
  }
  
  .hero-actions {
    justify-content: center;
  }
  
  .trust-indicators {
    justify-content: center;
    flex-wrap: wrap;
  }
  
  .stats-scorecards {
    grid-template-columns: 1fr;
    gap: 2rem;
    max-width: 450px;
    margin: 0 auto;
    min-height: auto;
  }
  
  .scorecard {
    padding: 2.5rem;
    height: 140px;
  }
  
  .scorecard-icon {
    width: 70px;
    height: 70px;
    font-size: 3rem;
  }
  
  .scorecard-content h3 {
    font-size: 2.2rem;
  }
  
  .scorecard-content p {
    font-size: 0.75rem;
  }
  
  .features-grid {
    grid-template-columns: 1fr;
  }
  
  .categories-grid {
    grid-template-columns: 1fr;
  }
  
  .footer-content {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }
  
  .footer-right {
    text-align: center;
  }
}
</style>